export default __webpack_public_path__ + "static/media/Bloodseraph's Girdle.4a28ba99.jpg";